import { render, staticRenderFns } from "./VMedia.vue?vue&type=template&id=55820547&"
import script from "./VMedia.vue?vue&type=script&lang=js&"
export * from "./VMedia.vue?vue&type=script&lang=js&"
import style0 from "./VMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports